import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ticketColors } from '../../../shared/theme/ticketColors';
import { styles } from '../posShared.styles';

type PosCartEmptyStateProps = {
  isWideLayout: boolean;
  inSheet: boolean;
  canEdit: boolean;
  onOpenScanner?: () => void;
  scanActionLabel?: string;
};

export function PosCartEmptyState({
  isWideLayout,
  inSheet,
  canEdit,
  onOpenScanner,
  scanActionLabel = 'Escanear',
}: PosCartEmptyStateProps) {
  return (
    <View style={styles.cartEmptyPanel} testID="pos.cart.empty">
      <View style={styles.cartEmptyIconBadge}>
        <Ionicons name="receipt-outline" size={18} color={ticketColors.ink3} />
      </View>
      <View style={styles.cartEmptyTextBlock}>
        <Text style={styles.cartEmptyHint}>
          {isWideLayout && !inSheet
            ? 'Tocá un producto en el catálogo o buscá a la izquierda.'
            : 'Agregá un ítem para cobrar.'}
        </Text>
        {!isWideLayout && !inSheet && canEdit && onOpenScanner ? (
          <View style={styles.cartEmptyShortcuts}>
            <TouchableOpacity
              style={styles.cartEmptyShortcutBtn}
              onPress={onOpenScanner}
              accessibilityRole="button"
              accessibilityLabel={scanActionLabel}
              testID="pos.cart.empty.scan"
            >
              <Ionicons name="barcode-outline" size={14} color={ticketColors.brandInk} />
              <Text style={styles.cartEmptyShortcutText}>{scanActionLabel}</Text>
            </TouchableOpacity>
          </View>
        ) : null}
      </View>
    </View>
  );
}
